import React, { useEffect, useState } from 'react';
import { CloseSvg } from "../svg"

import '../../../styles/common/promos/flash-message-banner.scss';

const dismissalCheck = () => {
	if (typeof(document) !== 'undefined') {
		if (document.cookie.split(';').filter(item => {
			return item.trim().indexOf('pdrIADownMessageDismissed=') === 0
		}).length) {
			return true;
		}

		return false;
	}

	return true;
};

const FlashMessageBanner = ({ path }) => {
	const [showBanner, setShowBanner] = useState(false);

	useEffect(() => {
		setShowBanner(!dismissalCheck());
	}, []);

	if (path.substring(0, 5) === '/shop' || path.substring(0, 8) === '/product') {
		return null;
	}

	return showBanner && (
		<div role="complementary" aria-label="Temporary Notice" className="sitewide-banner flash-message-banner">
			<div className="contents page-width">
				<div className="flash-message-contents">
					<p className="flash-message">
						Due to <a
						href="https://theweek.com/tech/internet-archive-under-attack-wayback-machine-cybersecurity-ddos"
						target="_blank" rel="noreferrer noopener">issues at Internet Archive</a>, most of our book readers and audio/film players are not currently functioning. Hopefully normal service resumes soon!
					</p>
					<button
						ariaLabel="Dismiss Message"
						title="Dismiss Message"
						className="dismiss"
						onClick={() => {
							document.cookie = "pdrIADownMessageDismissed=true; expires=Fri, 31 Dec 9999 23:59:59 GMT";
							setShowBanner(false);
						}}
					>
						{CloseSvg}
					</button>
				</div>
			</div>
		</div>
	);
};

export default FlashMessageBanner;